import { render, staticRenderFns } from "./AgentTransactionsReportTrademarkProvisionalList.vue?vue&type=template&id=4d83dd5f&"
import script from "./AgentTransactionsReportTrademarkProvisionalList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportTrademarkProvisionalList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportTrademarkProvisionalList.vue?vue&type=style&index=0&id=4d83dd5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports